import * as React from 'react';

import {useQuery} from '@apollo/react-hooks';

import type {
    LeadBackboneUpdate as LeadBackboneUpdateQuery,
    LeadBackboneUpdateVariables,
} from 'nutshell-graphql-types';

import LEAD_BACKBONE_UPDATE from '../queries/lead-backbone-update.graphql';

/**
 * This hook will watch for lead backbone updates. When one occurs, it will run
 * the LeadBackboneUpdate query in order to refresh some lead fields in the
 * Apollo cache.
 *
 * To have more fields automatically update on a lead backbone update, add them
 * to the LeadBackboneUpdate query.
 */
export const useLeadBackboneWatch = (id: string): void => {
    const {refetch} = useQuery<LeadBackboneUpdateQuery, LeadBackboneUpdateVariables>(
        LEAD_BACKBONE_UPDATE,
        {
            variables: {
                id,
            },
        }
    );

    React.useEffect(() => {
        if (typeof Lead !== 'undefined' && Lead.events) {
            const onBackboneUpdate = () => {
                refetch();
            };

            $(window).on(Lead.events.LeadBackboneModelDidUpdate, onBackboneUpdate);
            $(window).on('entityWasEdited', onBackboneUpdate);

            return () => {
                $(window).off(Lead.events.LeadBackboneModelDidUpdate, onBackboneUpdate);
                $(window).off('entityWasEdited', onBackboneUpdate);
            };
        }
    }, [id, refetch]);
};
